/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
/// ROUTER ///
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
/// ACTIONS ///
import { getPriceList } from "api/actions/price_list";
import { setBreadcrumbs } from "api/actions/ui/set";
/// MUI ///
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
/// COMPONENTS ///
import PageTitle from "components/universal/page/title";
/// FM ///
import { motion } from "framer-motion";
/// STYLES ///
import { content_container_style } from "styles/universal/page";
import { header_style } from "styles/universal/section_header";
import { list_container_style } from "styles/universal/page";
import { item_style } from "styles/quote_preview/section";
/// MOTION ///
import { m_init_page } from "motion/page";
import { m_anim_page } from "motion/page";
import { m_exit_page } from "motion/page";
import { page_trans } from "motion/page";
/// ICONS  ///
import { faBorderTopLeft } from "@fortawesome/free-solid-svg-icons";
import { faHelmetSafety } from "@fortawesome/free-solid-svg-icons";
import { faMound } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import { faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
/// FA ///
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/// TYPE VALUES ///
import { getMaterialTypeDisplay } from "values/material";
/// URLS ///
import { bump_url } from "components/navigation/endpoints";
import { cutout_url } from "components/navigation/endpoints";
import { corner_url } from "components/navigation/endpoints";
import { edges_url } from "components/navigation/endpoints";
import { labor_url } from "components/navigation/endpoints";
/// BREADCRUMBS ///
import { list } from "values/breadcrumbs/market/pl";
import { overview } from "values/breadcrumbs/market/pl";
/// STYLES ///
import { mat_tile_style } from "styles/material";
/// ANIMATION ///
import { mat_tile_anim } from "styles/material";

export default function PriceL() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { price_list } = useAppSelector(state => state.price_list);

  useEffect(() => {
    if (id) {
      dispatch(getPriceList(id));
    }
    dispatch(setBreadcrumbs([
      list,
      { ...overview, label: price_list?.name ?? "Overview", url: overview.url.replace("id", id) }]));
  }, [dispatch, id, price_list?.name]);

  return (
    <motion.div initial={m_init_page} exit={m_exit_page} animate={m_anim_page} transition={page_trans} style={content_container_style}>
      <Grid container sx={list_container_style}>
        <PageTitle title={price_list?.name ?? ""} endProps={<div></div>} />
        <Grid item xs={12}>
          <Box sx={header_style}></Box>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" sx={item_style()}>
            <b>Material Type</b>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" align="right" sx={item_style()}>
            {getMaterialTypeDisplay(price_list?.material_type ?? "")}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Box display="flex" flexDirection="row" gap="20px" justifyContent="space-evenly" alignItems="center" marginTop="10px" width="100%" paddingTop="25px">
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(bump_url)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Bumps
              </Typography>
              <FontAwesomeIcon icon={faMound} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(cutout_url)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Cutouts
              </Typography>
              <FontAwesomeIcon icon={faSquare} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(corner_url)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Corners
              </Typography>
              <FontAwesomeIcon icon={faBorderTopLeft} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(edges_url)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Edges
              </Typography>
              <FontAwesomeIcon icon={faWindowMinimize} size="2xl" />
            </motion.button>
            <motion.button
              initial={{ opacity: 0, right: 20 }}
              animate={{ opacity: 1, right: 0, transition: { delay: 0.2 } }}
              style={mat_tile_style}
              whileHover={mat_tile_anim}
              onClick={() => navigate(labor_url)}>
              <Typography variant="h6" sx={{ marginTop: "15px" }}>
                Labor Charges
              </Typography>
              <FontAwesomeIcon icon={faHelmetSafety} size="2xl" />
            </motion.button>
          </Box>
        </Grid>
      </Grid>
    </motion.div >
  )
}
